import { z } from 'zod';
import { paginationSchema } from '@core/schemas/pagination.schema';
import { emailSchema } from '@pages/Auth/schemas/auth.schema';
import { ERROR_MESSAGE } from '@shared/constants/errorMessage.constant';
import { USER_STATUSES, USER_TYPES } from '@shared/constants/user.constant';
import { permissionsSchema } from '@shared/schemas/permissionService.schema';

const userSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  username: z.string().optional(),
  email: emailSchema,
  roles: z.array(z.string()),
  status: z.enum(USER_STATUSES),
  type: z.enum(USER_TYPES),
  createdAt: z.iso.datetime(),
  lastActivityAt: z.iso.datetime().nullable()
});

const fullUserSchema = userSchema.extend({
  // permissions: z.array(z.string())
  permissions: permissionsSchema
});

const usersResponseSchema = paginationSchema.extend({
  users: z.array(userSchema)
});

const userResponseSchema = z.object({
  user: fullUserSchema
});

const updateUserSchema = z.object({
  name: z
    .string()
    .min(1, { message: ERROR_MESSAGE.required })
    .max(50, { message: ERROR_MESSAGE.maxLength(50) }),
  roles: z.array(z.string()).min(1, { message: ERROR_MESSAGE.required }).readonly()
});

const updateUserFormSchema = updateUserSchema.pick({ name: true }).extend({
  roles: z.array(z.object({ label: z.string(), value: z.string() })).readonly()
});

const inviteUserFormSchema = updateUserFormSchema.extend({
  email: emailSchema
});

const inviteUserSchema = updateUserSchema.extend({
  link: z.string(),
  email: emailSchema
});

export {
  userSchema,
  fullUserSchema,
  usersResponseSchema,
  userResponseSchema,
  updateUserSchema,
  inviteUserFormSchema,
  inviteUserSchema,
  updateUserFormSchema
};
